import React from "react";

export const typeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16.015 16.015"
  >
    <path
      className="a"
      d="M310.6,240h-3.128a.469.469,0,0,0,0,.938H310.6a.469.469,0,0,0,0-.938Z"
      transform="translate(-297.397 -232.493)"
    />
    <path
      className="a"
      d="M368.72,180h-1.251a.469.469,0,1,0,0,.938h1.251a.469.469,0,0,0,0-.938Z"
      transform="translate(-355.521 -174.37)"
    />
    <path
      className="a"
      d="M310.6,60h-3.128a.469.469,0,0,0,0,.938H310.6a.469.469,0,0,0,0-.938Z"
      transform="translate(-297.397 -58.123)"
    />
    <path
      className="a"
      d="M15.546,9.384V.938a.469.469,0,1,0,0-.938H7.726a.469.469,0,0,0,0,.938v2.5H6.018a2.189,2.189,0,1,0-3.559.044A2.976,2.976,0,0,0,0,6.412V9.853A1.408,1.408,0,0,0,1.407,11.26h.04a1.363,1.363,0,0,0,.43-.082v3.43a1.407,1.407,0,0,0,2.346,1.048,1.407,1.407,0,0,0,2.346-1.048V6.256H7.726V9.384a.469.469,0,1,0,0,.938h3.441V11.96L8.9,15.281a.469.469,0,1,0,.775.529l1.489-2.184v1.92a.469.469,0,1,0,.938,0v-1.92l1.489,2.184a.469.469,0,1,0,.775-.529L12.1,11.96V10.322h3.441a.469.469,0,1,0,0-.938ZM4.223.938A1.251,1.251,0,1,1,2.971,2.19,1.253,1.253,0,0,1,4.223.938ZM6.1,5.317a.469.469,0,0,0-.469.469v8.821a.469.469,0,1,1-.938,0V9.915a.469.469,0,1,0-.938,0v4.692a.469.469,0,1,1-.938,0V6.516a.469.469,0,0,0-.938,0V9.833a.482.482,0,0,1-.456.489.469.469,0,0,1-.483-.469V6.412A2.035,2.035,0,0,1,2.971,4.379H9.759a.469.469,0,1,1,0,.938ZM8.664,9.384V6.256H9.759a1.406,1.406,0,0,0,1.4-1.564H13.2a.469.469,0,1,0,0-.938H10.642a1.4,1.4,0,0,0-.883-.313H8.664V.938h5.943V9.384Z"
    />
  </svg>
);

export const modeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 18.867 18.941"
  >
    <g transform="translate(-1.001)">
      <path
        className="a"
        d="M158.214,4.439a.555.555,0,0,0,0-1.11H157.6a2.759,2.759,0,0,0-.4-.974l.433-.433a.555.555,0,1,0-.785-.785l-.433.433a2.759,2.759,0,0,0-.974-.405V.555a.555.555,0,1,0-1.11,0v.611a2.76,2.76,0,0,0-.974.405l-.433-.433a.555.555,0,0,0-.785.785l.433.433a2.758,2.758,0,0,0-.4.974h-.611a.555.555,0,1,0,0,1.11h.611a2.759,2.759,0,0,0,.4.974l-.433.433a.555.555,0,0,0,.785.785l.433-.433a2.759,2.759,0,0,0,.974.405v.611a.555.555,0,1,0,1.11,0V6.6a2.76,2.76,0,0,0,.974-.405l.433.433a.555.555,0,1,0,.785-.785l-.433-.433a2.758,2.758,0,0,0,.4-.974Zm-3.329,1.11a1.665,1.665,0,1,1,1.665-1.665A1.667,1.667,0,0,1,154.884,5.549Z"
        transform="translate(-144.45)"
      />
      <path
        className="a"
        d="M201.562,365.869a.555.555,0,0,0-.308.964,2.77,2.77,0,1,0,0-4.117.555.555,0,0,0,.308.964,1.1,1.1,0,0,1,0,2.189Zm1.349-2.748a1.664,1.664,0,1,1,0,3.307,2.206,2.206,0,0,0,0-3.307Z"
        transform="translate(-192.667 -348.608)"
      />
      <path
        className="a"
        d="M1.163,100.6a.555.555,0,0,0,.785.785l.166-.166a8.3,8.3,0,0,0,3.573,6.612.555.555,0,1,0,.634-.911,7.19,7.19,0,0,1-3.087-5.684l.149.149a.555.555,0,0,0,.785-.785l-.834-.834a7.159,7.159,0,0,1,1.949-3.823.555.555,0,0,0-.792-.777,8.265,8.265,0,0,0-2.25,4.358Z"
        transform="translate(0 -91.486)"
      />
      <path
        className="a"
        d="M366.166,99.947a.555.555,0,0,0-.785-.785l-.166.166a8.265,8.265,0,0,0-2.435-5.659.555.555,0,1,0-.785.785,7.163,7.163,0,0,1,2.109,4.867l-.158-.158a.555.555,0,1,0-.785.785l.842.843a7.207,7.207,0,0,1-3,4.692.555.555,0,1,0,.634.911,8.313,8.313,0,0,0,3.447-5.37Z"
        transform="translate(-346.461 -90.047)"
      />
    </g>
  </svg>
);

export const timeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="19"
    viewBox="0 0 16.232 19.744"
  >
    <g transform="translate(-519.225 -139.852)">
      <path
        className="a"
        d="M527.337,159.824a8.123,8.123,0,1,1,.387-.009C527.594,159.821,527.465,159.824,527.337,159.824Zm.008-15.382q-.172,0-.346.008a7.259,7.259,0,1,0,.346-.008Z"
        transform="translate(0 -0.229)"
      />
      <path
        className="a"
        d="M524.953,155.892a1.249,1.249,0,0,1-.883-2.132l2.487-2.487v-3.279a1.249,1.249,0,0,1,2.5,0v3.733a1.509,1.509,0,0,1-.564,1.147l-2.654,2.652A1.241,1.241,0,0,1,524.953,155.892Zm2.852-8.3a.4.4,0,0,0-.4.4v3.456a.424.424,0,0,1-.124.3l-2.612,2.612a.4.4,0,0,0,.565.564l2.639-2.639c.013-.013.031-.029.054-.049a.667.667,0,0,0,.277-.511v-3.733A.4.4,0,0,0,527.8,147.595Z"
        transform="translate(-0.274 -0.422)"
      />
      <path
        className="a"
        d="M533.958,144.724a1.088,1.088,0,0,1-.445-.1l-3.732-1.683a1.083,1.083,0,0,1-.542-1.432,2.828,2.828,0,0,1,3.734-1.413l.56.253a2.824,2.824,0,0,1,1.412,3.734,1.085,1.085,0,0,1-.987.637Zm-.1-.87a.234.234,0,0,0,.308-.116,1.973,1.973,0,0,0-.987-2.61l-.56-.253a1.976,1.976,0,0,0-2.61.988.233.233,0,0,0,.116.308Z"
        transform="translate(-0.607 0)"
      />
      <path
        className="a"
        d="M521.249,144.724a1.085,1.085,0,0,1-.987-.637,2.822,2.822,0,0,1,1.412-3.734l.56-.253a2.826,2.826,0,0,1,3.733,1.413,1.082,1.082,0,0,1-.541,1.432l-3.733,1.683A1.08,1.08,0,0,1,521.249,144.724Zm2.144-4.025a1.974,1.974,0,0,0-.81.176l-.559.253a1.973,1.973,0,0,0-.987,2.61.233.233,0,0,0,.13.122.228.228,0,0,0,.177-.006l3.733-1.683a.232.232,0,0,0,.116-.308,1.962,1.962,0,0,0-1.1-1.035A1.986,1.986,0,0,0,523.394,140.7Z"
        transform="translate(-0.048)"
      />
    </g>
  </svg>
);

export const priceIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.555"
    height="11.455"
    viewBox="0 0 19.555 11.455"
  >
    <g transform="translate(-390.444 -235.599)">
      <path
        className="a"
        d="M409.21,244.165h-1.321a.436.436,0,1,1,0-.872h.885v-4.924h-.885a.436.436,0,0,1,0-.872h1.321a.436.436,0,0,1,.435.436v5.8A.436.436,0,0,1,409.21,244.165Z"
        transform="translate(-2.878 -0.321)"
      />
      <path
        className="a"
        d="M404,245.419a.436.436,0,0,1-.26-.787,5.377,5.377,0,0,0,0-8.246.436.436,0,1,1,.518-.7,6.245,6.245,0,0,1,0,9.649A.43.43,0,0,1,404,245.419Z"
        transform="translate(-2.22)"
      />
      <g transform="translate(390.444 235.599)">
        <path
          className="a"
          d="M407.227,245.419H391.563a1.12,1.12,0,0,1-1.119-1.119v-7.582a1.12,1.12,0,0,1,1.119-1.119h15.664a1.121,1.121,0,0,1,1.119,1.119V244.3A1.121,1.121,0,0,1,407.227,245.419Zm-15.664-8.947a.247.247,0,0,0-.248.247V244.3a.247.247,0,0,0,.248.247h15.664a.247.247,0,0,0,.248-.247v-7.582a.247.247,0,0,0-.248-.247Z"
          transform="translate(-390.444 -235.599)"
        />
        <path
          className="a"
          d="M394.1,244.165h-1.325a.436.436,0,0,1-.435-.436v-5.8a.436.436,0,0,1,.435-.436H394.1a.436.436,0,0,1,0,.872h-.889v4.924h.889a.436.436,0,1,1,0,.872Z"
          transform="translate(-390.765 -235.92)"
        />
        <path
          className="a"
          d="M397.835,245.419a.431.431,0,0,1-.259-.086,6.244,6.244,0,0,1,0-9.649.436.436,0,0,1,.518.7,5.377,5.377,0,0,0,0,8.246.436.436,0,0,1-.259.787Z"
          transform="translate(-391.265 -235.599)"
        />
        <g transform="translate(6.863 1.635)">
          <path
            className="a"
            d="M401.44,243.622h-1.991a.436.436,0,1,1,0-.872h1.991a.57.57,0,0,0,.57-.57v-.205a.57.57,0,0,0-.57-.57h-1.294a1.443,1.443,0,0,1-1.441-1.442v-.206a1.443,1.443,0,0,1,1.441-1.441h1.991a.436.436,0,0,1,0,.872h-1.991a.57.57,0,0,0-.57.569v.206a.571.571,0,0,0,.57.57h1.294a1.443,1.443,0,0,1,1.441,1.442v.205A1.443,1.443,0,0,1,401.44,243.622Z"
            transform="translate(-398.705 -237.694)"
          />
          <path
            className="a"
            d="M401.13,244.117a.436.436,0,0,1-.436-.436V238a.436.436,0,1,1,.872,0v5.677A.436.436,0,0,1,401.13,244.117Z"
            transform="translate(-399.042 -237.567)"
          />
        </g>
      </g>
      <g transform="translate(392.808 237.944)">
        <path
          className="a"
          d="M408.791,247.531H393.724a.436.436,0,0,1,0-.872h15.067a.818.818,0,0,0,.818-.817v-6.984a.436.436,0,1,1,.871,0v6.984A1.691,1.691,0,0,1,408.791,247.531Z"
          transform="translate(-393.289 -238.422)"
        />
      </g>
    </g>
  </svg>
);
